<login-header></login-header>
<div class="login_hero text-center">
  <div class="px-90 m-auto">
    <div class="login_options d-md-grid">

      <!-- Families Section -->
      <div class="single_option for_families d-flex justify-content-center align-items-center">
        <div class="login_content">
          
          <div class="login_texttop mb-3">
            <img src="/assets/images/families-icon.svg" width="50" height="50" alt="" class="mb-3">
            
            <h2 class="lp_h2 text-capitalize">For Families</h2>
            
            <p class="text-capitalize">
              Prepare for your family’s day-to-day needs, important milestones, 
              and inevitable emergencies all in one place.
            </p>
          </div>

          <button type="button"  routerLink="/questionnaires" class="primary_btn mb-3">Sign Up</button>
          <p class="sub-text"> Already have an account? <button type="button" class="text_red info_btn" (click)="auth.login()" >Log in</button></p>
          

        </div>
      </div>

      <!-- Professionals Section -->
      <div class="single_option for_professional d-flex justify-content-center align-items-center">
        <div class="login_content">

          <div class="login_texttop mb-3">
            <img src="/assets/images/professional-icon.svg" width="46" height="46" alt="" class="mb-3">
            
            <h2 class="lp_h2 text-capitalize">For Professionals</h2>
            
            <p class="text-capitalize">
              With our secure storage, you can give your clients peace of mind 
              knowing all their critical documents are stored in one place
            </p>
          </div>

          <button routerLink="/professional/signup" type="button" class="border_btn red_border mb-3">Sign Up</button>
        <p class="sub-text"> Already have an account? <button type="button" (click)="ContinueProfiessional()" class="text_red info_btn">Log in</button></p>

        </div>
      </div>

    </div>
  </div>
</div>
<app-footer></app-footer>